import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as PropTypes from "prop-types";
import TextFieldWrapper from "../../layouts/forms/text-field-wrapper";
import * as Yup from "yup";
import {Form, Formik} from "formik";
import ButtonWrapper from "../../layouts/forms/button-wrapper";
import {getMedidasThunk, storeMedidaThunk} from "../../../redux/medidas/medidas.thunk";
import {connect} from "react-redux";
import {CircularProgress} from "@mui/material";

function Fragment(props) {
    return null;
}

Fragment.propTypes = {children: PropTypes.node};
const ProductoSaleAddDialog = (props) => {

    const {open, onClose} = props;

    const INITIAL_FROM_STATE = {
        nombre: '',
        descripcion: '',
    };

    const FORM_VALIDATION = Yup.object().shape({
        nombre: Yup.string().required('El nombre es requerido'),
    });

    const handleClose = () => {
        onClose();
    };

    const onStore = async (values) => {
        console.log(values);
        await props.storeMedida(values);
        onClose(props.medida);
        await props.getMedidas();
    }

    return (
        <Dialog
            fullWidth={false}
            open={open}
            onClose={handleClose}>
            <DialogTitle>Cuantos?</DialogTitle>
            <DialogContent>
                {props.statusMedida === 'loading' ?
                    <div className="text-center">
                        <CircularProgress/>
                        <p>Registrando...</p>
                    </div>
                    : <Formik initialValues={INITIAL_FROM_STATE}
                              validationSchema={FORM_VALIDATION}
                              onSubmit={values => onStore(values)}>
                        <Form>
                            <div className="my-3">
                                <TextFieldWrapper name="nombre" label="Nombre"/>
                            </div>
                            <div className="my-3">
                                <TextFieldWrapper name="descripcion" label="Descripcion" multiline={true}
                                                  rows={3}/>
                            </div>
                            <div className="my-3">
                                <ButtonWrapper>AÑADIR</ButtonWrapper>
                            </div>
                        </Form>
                    </Formik>}
            </DialogContent>
        </Dialog>
    );
}

const mapStateToProps = (state) => {
    console.log("state", state);
    return {
        medida: state.medidas.medida,
        statusMedida: state.medidas.status,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMedidas: () => dispatch(getMedidasThunk()),
        storeMedida: (obj) => dispatch(storeMedidaThunk(obj)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductoSaleAddDialog);
